const state = {
    color: null,
    defaultColor: null,
    containerIdentifier: null,
    containerDiv: null,
    colorPickerPosition: {
        top: 0,
        left: 0
    },
};
const getters = {
    getDefaultColor: (state) => state.defaultColor,
    getColorPickerPosition: (state) => state.colorPickerPosition,
    getColorPickerIdentifier: (state) => state.containerIdentifier,
    getColorPickerDiv: (state) => state.containerDiv,
    getColorSelected: (state) => state.color
};
const mutations = {
    setColorSelected(state, data) {
        state.color = data;
    },
    setColorPickerData(state, data) {
        state.colorPickerPosition = data?.position || { top: 0, left: 0 };
        state.containerIdentifier = data?.containerIdentifier || null;
        state.containerDiv = data?.containerDiv || null;
    },
    setDefaultColor(state, data) {
        state.defaultColor = data;
    },
};
const actions = {
    setDefaultColor({ commit }, data) {
        commit('setDefaultColor', data);
    },
    setColorSelected({ commit }, data) {
        commit('setColorSelected', data);
    },
    setColorPickerData({ commit }, data) {
        commit('setColorPickerData', data);
    },
    clearColorPickerData({ commit }) {
        commit('setColorPickerData');
    }
};
export default {
    state,
    getters,
    mutations,
    actions
};
